export class OrderDetail {
    orderId: string;
    packageSizeId: string;
    quantity: number;
    enabled: boolean;
}
